import React from 'react';
import { BookOpen, Clock, Compass, CheckSquare, ShieldAlert } from 'lucide-react';
import { FadeIn } from './FadeIn';
const features = [{
  name: '50 Step-by-Step Activities',
  description: 'Low-mess, high-engagement setups using items you already have in your kitchen drawers.',
  icon: BookOpen
}, {
  name: 'The 2-Minute Setup Hack',
  description: 'Strategies to trigger play in less time than it takes to find the remote.',
  icon: Clock
}, {
  name: 'The Energy-Level Master Guide',
  description: 'How to tell exactly what kind of play your child needs to avoid a meltdown.',
  icon: Compass
}, {
  name: 'The "Sanity Pantry" Checklist',
  description: 'The 6 household staples that can distract a toddler for 20+ minutes.',
  icon: CheckSquare
}, {
  name: 'The Emergency Sanity Kit',
  description: 'A "break glass in case of emergency" list for your hardest days.',
  icon: ShieldAlert
}];
export function WhatYouGet() {
  return <section className="bg-cream py-24 sm:py-32" data-id="element-203">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-204">
        <div className="mx-auto max-w-2xl text-center mb-16" data-id="element-205">
          <FadeIn data-id="element-206">
            <h2 className="font-serif text-3xl font-bold tracking-tight text-navy sm:text-4xl" data-id="element-207">
              What's Inside The Playbook
            </h2>
          </FadeIn>
        </div>

        <div className="mx-auto max-w-4xl" data-id="element-208">
          <div className="space-y-6" data-id="element-209">
            {features.map((feature, index) => <FadeIn key={feature.name} delay={index * 0.1} direction="left" data-id="element-210">
                <div className="flex flex-col sm:flex-row gap-6 bg-white rounded-2xl p-6 sm:p-8 shadow-sm hover:shadow-soft transition-shadow items-start sm:items-center" data-id="element-211">
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-amber-light text-amber" data-id="element-212">
                    <feature.icon className="h-7 w-7" data-id="element-213" />
                  </div>
                  <div data-id="element-214">
                    <h3 className="text-xl font-semibold text-navy mb-2" data-id="element-215">
                      {feature.name}
                    </h3>
                    <p className="text-muted leading-relaxed" data-id="element-216">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}